import React from "react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/content";
import { Sparkle, InstagramLogo, VideoCamera, TrendUp } from "@phosphor-icons/react";

const VALUES = ["Purpose", "Creativity", "Integrity"];

const FEATURES = [
  { icon: InstagramLogo, title: "Social-First Approach", desc: "Content crafted for the platforms your audience actually scrolls." },
  { icon: VideoCamera, title: "Scroll-Stopping Content", desc: "Reels, posts and stories designed to get noticed and shared." },
  { icon: TrendUp, title: "Measurable Growth", desc: "Real engagement and reach that turn followers into customers." },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 md:py-36 bg-navy">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-6">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Our Mission</p>
          <h2 className="font-heading font-light text-3xl sm:text-4xl lg:text-5xl text-[#F6F4F0] leading-tight mb-8">
            Helping businesses grow through creative, strategic social media marketing.
          </h2>
          <div className="space-y-5 text-[#E5E7EB] font-light leading-relaxed">
            <p>
              Founded by two ambitious high school students with a passion for business and innovation, 4PS Marketing Group LLC lives and breathes social media — bringing fresh perspectives, modern content strategies, and a genuine commitment to delivering real results.
            </p>
            <p>
              We believe every business — regardless of size — deserves a strong social presence, meaningful customer connections, and marketing that creates lasting impact. As trusted partners, we're dedicated to helping our clients grow with <span className="text-gold">purpose, creativity, and integrity.</span>
            </p>
          </div>

          <div className="flex flex-wrap gap-3 mt-10">
            {VALUES.map((v) => (
              <span key={v} className="inline-flex items-center gap-2 border border-[#C8A96A]/40 text-gold text-xs uppercase tracking-[0.2em] px-4 py-2">
                <Sparkle size={12} weight="fill" /> {v}
              </span>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6">
        <Reveal delay={0.12}>
          <div className="relative overflow-hidden">
            <img src={IMAGES.social} alt="Social media marketing content" className="w-full h-[360px] object-cover grayscale-[15%]" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A]/70 via-transparent to-transparent" />
          </div>
          <div className="mt-6 space-y-4">
            {FEATURES.map((f) => (
              <div key={f.title} className="flex items-start gap-5 p-6 border border-[#F6F4F0]/12 bg-[#101f30] hover:border-[#C8A96A]/50 transition-colors duration-300">
                <f.icon size={30} weight="thin" className="text-gold shrink-0 mt-0.5" />
                <div>
                  <p className="font-heading text-lg text-[#F6F4F0]">{f.title}</p>
                  <p className="text-sm text-[#E5E7EB] font-light leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
